module.exports = __webpack_public_path__ + "media/videos/video-1a88b34ef8b8e56bde421b163f752913.flv";